import React from 'react'

import { SettingsRowEmpty } from '../StyledComponents/Settings'


const TableViewCellDescription = props => <SettingsRowEmpty>{props.text}</SettingsRowEmpty>

export default TableViewCellDescription



// WEBPACK FOOTER //
// ./src/components/Settings/TableViewCellDescription.js